/**
 * 車両カードのクリックに対する「選択ハイライト」と「詳細パネル」の遷移。
 *
 * - close: 詳細を閉じる
 * - keep : 詳細はそのまま（既に同じカードを表示している）
 * - open : そのカードの詳細を開く
 */
export type CardClickResult = {
  nextSelectedCardIds: Set<string>;
  detail: 'close' | 'keep' | 'open';
};

/**
 * @param cardId クリックされたカード
 * @param selectedCardIds 現在の選択ハイライト
 * @param openedVehicleCardId 詳細パネルが表示中の車両カード。未割当や未表示なら null
 *
 * 再クリック（そのカードだけを選択中）のときは、詳細が別物を表示していても閉じる。
 * 抽出前は `setSelectedCardIds` の updater 内から `setDetailSelection(null)` を撃っており、
 * updater が render フェーズで遅延実行される（＝ハンドラ末尾の setState より後にキューへ入る）
 * ため null が勝っていた。その最終状態をこの表で明示している。
 */
export function resolveCardClick(
  cardId: string,
  selectedCardIds: ReadonlySet<string>,
  openedVehicleCardId: string | null,
): CardClickResult {
  const isRepeatClick = selectedCardIds.size === 1 && selectedCardIds.has(cardId);
  if (isRepeatClick) {
    return { nextSelectedCardIds: new Set(), detail: 'close' };
  }
  return {
    nextSelectedCardIds: new Set([cardId]),
    detail: openedVehicleCardId === cardId ? 'keep' : 'open',
  };
}
